import type { ParticipationAggregate } from "../../shared/participation";

interface ParticipationSlideProps {
  readonly data: ParticipationAggregate;
}

export function ParticipationSlide({ data }: ParticipationSlideProps) {
  const eventName = data.apiId === "03" ? "前夜祭" : "後夜祭";

  return (
    <article className="content-slide participation-slide">
      <div className="participation-heading">
        <div>
          <p className="slide-kicker"><span>02</span> LIVE PARTICIPATION</p>
          <h2>現在の参加状況</h2>
        </div>
        <span className="api-badge">{eventName}</span>
      </div>

      <div className="participation-body">
        <div className="participation-score">
          <span className="participation-caption">認証済み人数</span>
          <div>
            <strong>{data.authenticatedCount.toLocaleString("ja-JP")}</strong>
            <span>/ {data.totalCount.toLocaleString("ja-JP")} 人</span>
          </div>
        </div>
        <div className="participation-rate">
          <strong>{data.participationRate.toFixed(1)}<small>%</small></strong>
          <span>参加率</span>
        </div>
        <div className="participation-meter-wrap">
          <div
            className="participation-meter"
            role="progressbar"
            aria-label="参加率"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={data.participationRate}
          >
            <span style={{ width: `${data.participationRate}%` }} />
          </div>
          <div className="participation-legend">
            <span><i className="legend-dot legend-dot--joined" />認証済み {data.authenticatedCount}人</span>
            <span><i className="legend-dot legend-dot--waiting" />未認証 {data.unauthenticatedCount}人</span>
          </div>
        </div>
      </div>
    </article>
  );
}
